export const IVORYPhotoStudioEn = {
  companyProfile: {
    name: 'IVORY Photo Studio',
    about:
      'IVORY Photo Studio is a premier photography studio specializing in capturing life’s most cherished moments with creativity and precision. From family events to weddings, we ensure every memory is preserved beautifully.',
    certifications:
      'Our team consists of certified professionals with years of experience in photography and event coverage.',
    specialization:
      'We specialize in a wide range of photography services, including family events, weddings, newborn sessions, maternity shoots, engagements, henna ceremonies, and cake smash sessions.',
    whyChooseUs: [
      'Experienced photographers with a creative touch.',
      'State-of-the-art equipment for stunning visuals.',
      'Tailored packages to suit your needs.',
      'Friendly and professional service.',
      'Quick delivery of high-quality edited photos.',
      'Flexible scheduling to accommodate your events.',
      'A passion for capturing moments that matter.',
    ],
    slogan: 'Preserving your memories, one click at a time!',
    vision:
      'To be the leading photography studio, known for capturing timeless memories with exceptional quality and creativity.',
    mission:
      'To provide outstanding photography services that celebrate life’s special moments, ensuring every client’s story is told beautifully.',
    values: [
      'Commitment to excellence in every shot.',
      'Creativity and innovation in photography.',
      'Building lasting relationships with our clients.',
      'Delivering high-quality results with attention to detail.',
      'Ensuring customer satisfaction at every step.',
    ],
    qualityStandards: [
      'Professional-grade equipment and techniques.',
      'Attention to detail in every photograph.',
      'Consistent quality across all services.',
    ],
    availability: {
      bookOnline:
        'Book your photography session through our website and let us capture your special moments.',
      location: 'Doha, Qatar - Al Gharafa',
      contact: {
        phone: '+974 40171730',
        email: 'info@ivory.qa',
        website: 'www.ivory.qa',
      },
    },
    closingStatement:
      'At IVORY Photo Studio, we are dedicated to turning your moments into lasting memories with creativity, professionalism, and care.',
  },
};

export const IVORYPhotoStudioAr = {
  companyProfile: {
    name: 'استوديو آيفوري',
    about:
      'استوديو آيفوري هو استوديو تصوير رائد متخصص في توثيق أجمل لحظات الحياة بإبداع ودقة. من المناسبات العائلية إلى حفلات الزفاف، نضمن أن يتم حفظ كل ذكرى بشكل جميل.',
    certifications:
      'يتكون فريقنا من محترفين معتمدين يتمتعون بسنوات من الخبرة في التصوير الفوتوغرافي وتغطية المناسبات.',
    specialization:
      'نحن متخصصون في مجموعة واسعة من خدمات التصوير الفوتوغرافي، بما في ذلك المناسبات العائلية، حفلات الزفاف، جلسات تصوير المواليد الجدد، جلسات الحمل، الخطوبة، حفلات الحناء، وجلسات تصوير كيك سماش.',
    whyChooseUs: [
      'مصورون ذوو خبرة ولمسة إبداعية.',
      'معدات حديثة للحصول على صور مذهلة.',
      'باقات مخصصة لتلبية احتياجاتك.',
      'خدمة ودية واحترافية.',
      'تسليم سريع للصور عالية الجودة بعد التعديل.',
      'جدولة مرنة لتناسب مناسباتك.',
      'شغف بتوثيق اللحظات التي تهمك.',
    ],
    slogan: 'نوثق ذكرياتك، لقطة بلقطة!',
    vision:
      'أن نكون الاستوديو الرائد في التصوير الفوتوغرافي، المعروف بتوثيق الذكريات الخالدة بجودة وإبداع استثنائيين.',
    mission:
      'تقديم خدمات تصوير فوتوغرافي متميزة تحتفي بلحظات الحياة الخاصة، مع ضمان أن يتم سرد قصة كل عميل بشكل جميل.',
    values: [
      'الالتزام بالتميز في كل لقطة.',
      'الإبداع والابتكار في التصوير.',
      'بناء علاقات دائمة مع عملائنا.',
      'تقديم نتائج عالية الجودة مع الاهتمام بالتفاصيل.',
      'ضمان رضا العملاء في كل خطوة.',
    ],
    qualityStandards: [
      'معدات وتقنيات احترافية.',
      'الاهتمام بالتفاصيل في كل صورة.',
      'جودة متسقة عبر جميع الخدمات.',
    ],
    availability: {
      bookOnline: 'احجز جلسة التصوير الخاصة بك عبر موقعنا الإلكتروني ودعنا نوثق لحظاتك الخاصة.',
      location: 'الدوحة، قطر - الغرافة',
      contact: {
        phone: '+974 40171730',
        email: 'info@ivory.qa',
        website: 'www.ivory.qa',
      },
    },
    closingStatement:
      'في استوديو آيفوري، نحن ملتزمون بتحويل لحظاتك إلى ذكريات خالدة بإبداع واحترافية واهتمام.',
  },
};
